import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE } from 'pathnames.js';
import { SORT_ORDER } from 'globals.js';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// LOCAL COMPONENTS
import ExcelButtons from 'routers/interface/tools/ExcelButtons';

// MAIN COMPONENT
const Fallout = () => (
  <Main>
    <Title documentTitle="Fallout" title="Fallout" tools={<ExcelButtons fileName="fallout" />} />
    <Filters>
      <Filters.Date.Range useAll />
      <Filters.Button.SalesType />
      <Filters.Button.NewUsed />
    </Filters>
    <Table.Sorted sortParam="sales_date" mobilePreviewKeys={['customer1_full_name', 'make_model', 'stock_num']} />
  </Main>
);

// EXPORT
export default getListData(Fallout, {
  key: 'fallout',
  fetchArgs: {
    endpoint: ENDPOINTS.sales.list.fallout
  },
  defaults: {
    startDate: Form.Date.OPTIONS.thisMonth.startDate,
    endDate: Form.Date.OPTIONS.thisMonth.endDate,
    salesType: 'R',
    sort: 'sales_date',
    order: SORT_ORDER.descending,
    startRow: null
  },
  columns: [
    {
      key: 'sales_time',
      label: 'Time',
      tooltip: 'Time when deal was entered into the system.',
      width: 70
    },
    COLUMNS.salesStatus,
    COLUMNS.salesPerson,
    COLUMNS.customer(INTERFACE.fallout),
    COLUMNS.ageOfVehicle,
    COLUMNS.newUsed,
    COLUMNS.purchaseLease,
    {
      ...COLUMNS.retailWholesale,
      key: 'sale_type_category_code'
    },
    COLUMNS.stockNumber,
    COLUMNS.makeModel,
    COLUMNS.trades,
    COLUMNS.frontendGross,
    COLUMNS.amAssignment,
    COLUMNS.amTime,
    COLUMNS.amStatus,
    COLUMNS.fmAssignment,
    COLUMNS.fmTime,
    COLUMNS.fmStatus,
    COLUMNS.sa1,
    COLUMNS.sa2,
    COLUMNS.sa3
  ],
  actions: [ACTIONS.open(INTERFACE.fallout, 'sales_id')]
});
